<template>
  <DoctorDashboardCard style="margin-top: 25px">
    <template v-slot:title>
      <h3>
        <v-icon class="primary--text pr-2">error_outline</v-icon>
        Lycée : Valider la fin du parcours
        <v-chip v-show="patients.length">{{patients.length}}</v-chip>
      </h3>
    </template>
    <template v-slot:text>
      <v-list v-if="patients.length" two-line>
        <template v-for="(patient, index) in patients">
          <router-link :to="'patients/' + patient.id + '/suivi'" class="plain-link">
            <span :key="index" style="display:flex">
              <span style="margin-right: auto; margin-left: 15px">
                <span>{{patient.first_name}} {{patient.last_name}}</span>
              </span>
              <v-icon color="primary">arrow_forward</v-icon>
            </span>
          </router-link>

          <v-divider color="gray" v-if="index + 1 < patients.length"/>
        </template>
      </v-list>
      <h2 v-else class="text-center pb-5"
          style="color: #757575">Aucun rapport d'élève ne doit être commenté.</h2>
    </template>
    <template v-slot:info-text>
      <span style="font-size: 17px">Les élèves de cette liste ont finis leurs questionnaires. Il ne leur manque plus qu'un rendez-vous.</span>
    </template>
  </DoctorDashboardCard>
</template>

<script>
  import api from 'api'
  import DoctorDashboardCard from 'components/Iriade/DoctorDashboardCard'
  import IriadeTextarea from 'components/Iriade/IriadeTextarea'
  import IriadeSelect from 'components/Iriade/IriadeSelect'
  import IriadeTextInput from 'components/Iriade/IriadeTextInput'
  import moment from 'moment'

  export default {
    components: {
      DoctorDashboardCard,
      IriadeTextarea,
      IriadeSelect,
      IriadeTextInput
    },

    data () {
      return {
        patients: [],
        ui: {
          loading: true,
        },
      }
    },

    mounted () {
      api.get(`dashboard/modules/find`, {params: {class_name: this.module.class_name}})
        .then(res => {
          this.ui.loading = false;
          this.patients = res.data;
        });
    },

    props: ['module']
  }
</script>
